/*
  Alpine `stains` component for the stain-solutions tool — extracted from
  sections/stain-solutions.liquid and snippets/stain-solutions.liquid (the two blocks were
  byte-identical) so it ships from one cacheable, deferred asset instead of inline script.

  The metaobject payload stays in the page (it is Liquid data) and is read from #stain-solutions-data.
  This file runs before alpine.min.js in document order, so the alpine:init listener is still
  registered in time.
*/
function alpineStainsData() {
  var node = document.getElementById('stain-solutions-data');
  if (!node) return [];
  try {
    return JSON.parse(node.textContent);
  } catch (error) {
    return [];
  }
}

document.addEventListener('alpine:init', () => {
  Alpine.data('stains', () => ({
    activeStain: null,
    handleStainClick(stain) {
      this.activeStain = stain
    },
    stains: alpineStainsData(),
    init() {
      this.activeStain = this.stains[0].name
    }
  }))
})
